import { Box, Grid, Typography } from "@mui/material";
import jsPDF from "jspdf";
import { useRef, useState } from "react";
import { Edit, useRecordContext, useTranslate } from "react-admin";
import { Customer, Order } from "../types";
const OrderTravelSheet = () => {
  const record = useRecordContext<Order>();

  return (
    <Edit title={"Order details"}>
      <TravelSheet />
    </Edit>
  );
};

const CustomerAddress = () => {
  const record = useRecordContext<Customer>();
  const translate = useTranslate();

  console.log("record============>>>>>>>>>>", record);
  
  if (!record?.bookData[0]?.pincode) {
    return (
      <>
        <Box pt="10px" display="block" width={"100%"}>
          <Typography fontWeight={500}>{"In Store Pickup Address"}</Typography>
        </Box>
        <Box pt="5px" display="block" width={"100%"}>
          <Typography>{record?.book_id?.store_id?.store_name}</Typography>
          <Typography> {record?.settingData?.pick_up_address},</Typography>

          <Typography>
            Open: 8am-4pm, Monday-Friday closed weekends and holidays
          </Typography>
          <Typography> {record?.settingData?.phone}</Typography>
          <Typography> {record?.settingData?.email}</Typography>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box pt="10px" display="block" width={"100%"}>
          <Typography fontWeight={500}>
            {translate("resources.commands.section.shipping_address")}
          </Typography>
        </Box>
        <Box pt="5px" display="block" width={"100%"}>
          <Typography>
            {record?.user_id?.first_name} {record?.user_id?.last_name}
          </Typography>
          <Typography>{record?.bookData[0]?.mobile_number}</Typography>
          <Typography>
            {record?.bookData[0]?.house_no_building} {record?.bookData[0]?.street}
          </Typography>
          <Typography>
            {record?.bookData[0]?.city} {record?.bookData[0]?.state}
          </Typography>
          <Typography>{record?.bookData[0]?.pincode}</Typography>
        </Box>
      </>
    );
  }
};

const TravelSheet = () => {
  const record = useRecordContext<Order>();
  const [image, setImage] = useState(undefined);
  const contentRef = useRef(null);

  const printDocument = () => {
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      putOnlyUsedFonts: true,
    });
    pdf.html((contentRef as any).current, {
      callback: (doc) => {
        console.log("TEST Rendered");
        doc.output("pdfobjectnewwindow", {
          filename: `travel-sheet-for-${record?.order_number}.pdf`,
        });
        // doc.save('report-a.pdf')
      },
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      x: 0,
      y: 0,
      width: 230, //target width in the PDF document
      windowWidth: 675, //window width in CSS pixels
    });
    // ;(pdf as any).addImage(imgData, "JPEG", 0, 0)
    // pdf.save(`travel-sheet-for-${record?.order_number}.pdf`)

    // html2canvas((contentRef as any).current).then((canvas: any) => {
    //   const imgData = canvas.toDataURL("image/png")
    //   setImage(imgData)
    //   // const pdf = new jsPDF({
    //   //   orientation: "portrait",
    //   //   unit: "mm",
    //   //   format: "a4",
    //   //   putOnlyUsedFonts: true,
    //   // })
    //   // ;(pdf as any).addImage(imgData, "JPEG", 0, 0)
    //   // pdf.save(`travel-sheet-for-${record?.order_number}.pdf`)
    // })
  };

  return (
    <Box display="flex" border={0} flexDirection="column" alignItems="center">
      {/* <button id="printDocument" onClick={printDocument}>
        Print
      </button> */}
      {/* {image && <img src={image} />} */}
      <Box
        display="flex"
        border={"1px solid lightgray"}
        padding={5}
        maxWidth="750px"
        flexDirection="column"
      >
        <Box
          display="flex"
          padding={5}
          maxWidth="750px"
          flexDirection="column"
          id="divToPrint"
          ref={contentRef}
        >
          {record.bookData.map((value: any, index: number) => (
            <>
              <Box
                display="flex"
                flexDirection="column"
                alignContent="end"
                justifyContent="center"
              >
                <Typography fontSize={25}>{value.book_size_name}</Typography>
              </Box>
              <Box display="flex" flexDirection="row" justifyContent="center">
                <Box display="flex" flexDirection="column">
                  <img
                    src={value?.book_cover_url}
                    id="image-cover"
                    height="300px"
                  />
                </Box>
                <Box display="flex" flexDirection="column">
                  <img
                    src={value?.pdf_thumnail}
                    id="image-pdf"
                    height="300px"
                  />
                </Box>
              </Box>
              <Box
                display="flex"
                pt="20px"
                flexDirection="row"
                justifyContent="start"
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" width={"100%"}>
                      Date : {record?.order_date}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" width={"100%"}>
                      Book Type : {value?.book_type}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" width={"100%"}>
                      Book size : {value?.book_size_name}
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" width={"100%"}>
                      <Box display="flex" pr={5}>
                        QTY : {record.book_qtys && record?.book_qtys.length > 0 ? record?.book_qtys[index] : 1}
                      </Box>
                      <Box display="flex">
                        Total Pages : {value?.total_pages}
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </>
          ))}

          {/* <Box
            display="flex"
            flexDirection="column"
            alignContent="end"
            justifyContent="center"
          >
            <Typography fontSize={25}>{record.book_size}</Typography>
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="center">
            <Box display="flex" flexDirection="column">
              <img
                src={record?.bookData?.book_cover_url}
                id="image-cover"
                height="300px"
              />
            </Box>
            <Box display="flex" flexDirection="column">
              <img
                src={record?.bookData?.pdf_thumnail}
                id="image-pdf"
                height="300px"
              />
            </Box>
          </Box>
          <Box
            display="flex"
            pt="20px"
            flexDirection="row"
            justifyContent="start"
          >
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" width={"100%"}>
                  Date : {record?.order_date}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" width={"100%"}>
                  Book Type : {record?.book_type}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" width={"100%"}>
                  Book size : {record?.book_size}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" width={"100%"}>
                  <Box display="flex" pr={5}>
                    QTY : {record?.book_qty}
                  </Box>
                  <Box display="flex">
                    Total Pages : {record?.bookData?.total_pages}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box> */}
          <Box
            display="flex"
            pt="30px"
            pb="10px"
            flexDirection="row"
            justifyContent="start"
          >
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" width={"100%"}>
                  {record?.user_id?.first_name} {record?.user_id?.last_name}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" width={"100%"}>
                  Order Number : {record?.order_number}
                </Box>
                <Box display="flex" width={"100%"}>
                  Store Name : {record?.book_id?.store_id?.store_name}
                </Box>
                <Box display="flex" flexWrap={"wrap"} width={"100%"}>
                  <CustomerAddress />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderTravelSheet;
